<div class="container">
  <ul class="mixed-loyalty-nav">
    <a
      class="nav-item"
      [routerLink]="['/rewards/marketplace']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'rewards.nav.marketplace' | translate }}</label>
    </a>
    <a
      class="nav-item"
      [routerLink]="['/rewards/events']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'rewards.nav.events' | translate }}</label>
    </a>

    <ng-container *notInProductCode="[productCode.Partners]">
      <a
        class="nav-item"
        [routerLink]="['/rewards/raffles']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'rewards.nav.lotto' | translate }}</label>
      </a>
    </ng-container>

    <a
      class="nav-item d-lg-flex d-none"
      [routerLink]="['/rewards/wallet']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'home.nav.wallet' | translate }}</label>
    </a>
  </ul>
</div>
